import { render, staticRenderFns } from "./MinimizeIcon.vue?vue&type=template&id=c375aa28&scoped=true&"
import script from "./MinimizeIcon.vue?vue&type=script&lang=js&"
export * from "./MinimizeIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c375aa28",
  null
  
)

export default component.exports